// Copyright (c) 2024 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    isLatest: t.Boolean,
    model: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        isLatest: false,
        model: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/state/criteria.js